import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { WaybillIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../../common';
import { ShipmentWaybillEndpoint } from '../../constants';
import { LatestNotification } from '../../../monitoring/models';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillNotificationsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentWaybillNotifications(waybillIdView: WaybillIdView): Observable<LatestNotification[]> {
    return this.http
      .withLoading()
      .get<LatestNotification[]>(
        `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
          ShipmentWaybillEndpoint.Notifications
        }?${getQueryStringFromObject(waybillIdView)}`,
      );
  }
}
